module.exports = __webpack_public_path__ + "static/media/AdaBotStanding.812879e6.png";